import { Device } from '@/device';

export enum DeviceType {
  UNKNOWN = 'UNKNOWN',
  NEO3 = 'NEO3',
  NEO3EYE = 'NEO3EYE',
  G2 = 'G2',
  G3 = 'G3',
}

export const GetDeviceType = (device: Device): DeviceType => {
  const deviceId = device.getDeviceProductId();
  const deviceName = device.getDeviceName();
  if (deviceId === undefined && deviceName === undefined) {
    return DeviceType.UNKNOWN;
  }
  // Check name first
  if (deviceName !== undefined && deviceName.toLowerCase().includes('pico neo 3 pro eye')) {
    return DeviceType.NEO3EYE;
  }
  if (deviceName !== undefined && deviceName.toLowerCase().includes('neo 3')) {
    return DeviceType.NEO3;
  }
  if (deviceName !== undefined && deviceName.toLowerCase().includes('pico g3')) {
    return DeviceType.G3;
  }
  // Fallback on device ID
  if (deviceId === undefined) {
    return DeviceType.UNKNOWN;
  }
  const deviceIdMap: Map<number, DeviceType> = new Map([
    [177, DeviceType.NEO3], // Neo 3
    [183, DeviceType.NEO3], // Neo 3 or G3
    [145, DeviceType.G2], // G2
  ]);
  const deviceType = deviceIdMap.get(deviceId);
  return deviceType === undefined ? DeviceType.UNKNOWN : deviceType;
};

export const IsLegacyDevice = (device: Device) => {
  const deviceType = GetDeviceType(device);
  switch (deviceType) {
    case DeviceType.G3:
    case DeviceType.NEO3:
    case DeviceType.NEO3EYE:
      return false;
    default:
      return true;
  }
};
